module.exports = "<div class=component-calendar-left> <div class=\"item-content item-content-1\"> <div class=left-calendar-set> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/left-content/left-content.html
// module id = 4884
// module chunks = 50